import React from 'react';
import './DeliveryStatus.css';

const DeliveryStatus = ({ status, variant = 'default', size = 'medium' }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'delivered':
      case 'collected':
        return { 
          text: 'Collected', 
          class: 'delivered'
        };
      case 'returned':
        return { 
          text: 'Returned', 
          class: 'returned'
        };
      case 'not-delivered':
      case 'not-collected':
      default:
        return { 
          text: 'Not Collected', 
          class: 'not-delivered'
        };
    }
  };

  const statusConfig = getStatusConfig(status);
  const classNames = [
    'delivery-status',
    `delivery-status--${statusConfig.class}`,
    `delivery-status--${variant}`,
    `delivery-status--${size}`
  ].join(' ');

  return (
    <div className={classNames}>
      <span className="delivery-status__text">{statusConfig.text}</span>
    </div>
  );
};

export default DeliveryStatus;
